import axios from "axios";
import { TENANT_PLATFORM } from "@hiver/bifrost-js/lib";
import { getState, setState, STORAGE_KEYS } from "../Constants/LocalStorage";
import { apiRoutes, Admin_Base_URL } from "../Constants/ApiRoutes";


const axiosInstanceHGT = axios.create({
  credentials: "include",
  withCredentials: true,
  baseURL: Admin_Base_URL,
});

const axiosInstanceKB = axios.create({
  credentials: "include",
  withCredentials: true,
  baseURL: process.env.REACT_APP_NEW_AUTH_BASEURL
});

export const getHeimdallCodeHOT = async () => {
  const sessionData =  getState(STORAGE_KEYS.HOT_SESSION_DATA) ?? {};
  return sessionData.authorization;
}

const getSessionHeadersHOT = () => {
  const sessionData = getState(STORAGE_KEYS.HOT_SESSION_DATA) ?? {};
  return ( {
      'access-token': sessionData['access-token'],
      'token-type': sessionData['token-type'],
      client: sessionData.client,
      expiry: sessionData.expiry,
      uid: sessionData.uid,
  } )
}

const profileMeHOT = async () =>{ 
    const response= await axiosInstanceKB.get(apiRoutes.kbProfileMe, {
      headers: getSessionHeadersHOT()
    });
    const { data } = response.data;
    const user_id = data.id;
    const usergroup_id = data.accounts[ 0 ].id; // consuming first UG by default assuming most users to have single UG.
    const tenantPlatform = TENANT_PLATFORM.HIVERWEB;
    const getTokenForLogin = getHeimdallCodeHOT;
    return {
      data: {
        user_id, 
        usergroup_id,
        tenantPlatform,
        getTokenForLogin
      }
    }
}

const profileMeHGT = async () => {
  try{
    const response = await axiosInstanceHGT.get(apiRoutes.getUserDetails);
    return response;
  }
  catch( error ){
      throw new Error("Profile Me Failed", { cause: {
        tenantId: TENANT_PLATFORM.GMAIL,
        error
        }
      }
    );
  }
}

export const getUserDetailsviaV2ProfileMe = () => {
  return Promise.any([profileMeHGT(), profileMeHOT() ]).catch( ( { errors } ) => {
    console.debug(errors);
    const error = errors.find( error => error.cause?.tenantId === TENANT_PLATFORM.GMAIL );
    throw error?.cause?.error;
  });
};

export const completeOAuthHGT = function (authToken, email) {
  const payload = `email=${email}&token=${authToken}`;
  return axiosInstanceHGT.post(apiRoutes.OAuthCompleteHGT, payload , {
    headers: { 
      "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8'
    },
  });
};

export const completeOAuthHOT = async ( sso_auth_token, email ) => {
  const body = {
    sso_auth_token,
    email
  };

  const response = await axiosInstanceKB.post(apiRoutes.kbCompleteOAuth, body );

  const sessionData = response.headers;

  /** storing HOT session data in localStorage. 
   *  this data is passed as headers for profile-me call where access-token is used to validate user session
   *  and bearer token is passed as code for bifrost.
  */
  setState(STORAGE_KEYS.HOT_SESSION_DATA, sessionData );

  return response;
}

export const newHiverLoginInit = (payload) => {
  return axiosInstanceHGT.post(apiRoutes.newHiverLoginInit, payload, {});
}

export const loginInitHOT = async(provider) => {
  const params = {
    params: {
      provider: provider
    }
  };
  return axiosInstanceKB.get(apiRoutes.kbLoginInit, params );
};

export const verifyEmailHOT = (email) => {
  return axiosInstanceKB.get(apiRoutes.kbVerifyEmail, { params: { email } });
};

export const passwordSignInHOT = async (email, password, otp_attempt = null) => {
  const body = { email, password };
  if (otp_attempt) body.otp_attempt = otp_attempt;
  const response = await axiosInstanceKB.post(apiRoutes.kbAuthSignIn, body);
  const sessionData = response.headers;
  setState(STORAGE_KEYS.HOT_SESSION_DATA, sessionData);
  return response;
};

export const validateTokenHOT = (accessToken) => {
  return axiosInstanceKB.get(apiRoutes.kbValidateToken, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const getStoredAccessTokenHOT = () => {
  const sessionData = getState(STORAGE_KEYS.HOT_SESSION_DATA) ?? {};
  const accessToken = sessionData["access-token"] ?? sessionData["Access-Token"];
  if (accessToken) return accessToken;
  const auth = sessionData.Authorization ?? sessionData.authorization;
  if (auth && /^Bearer\s+/i.test(auth)) return auth.replace(/^Bearer\s+/i, "").trim();
  return null;
};